var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportsComponent',{attrs:{"urls":_vm.urls,"mandatory-filter":[
    {
      name: 'report_date_month_range',
      title: 'Date range',
      valueFieldName: '.select',
    },
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }